import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import Button from '@atlaskit/button';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import { LinkClickedEvent } from '@atlassian/mpac-analytics';
import { HostingDisplayName } from '@atlassian/mpac-types';
import { MarketplacePricingTierModeValues, MarketplacePricingTierTypeValues } from '@atlassian/mpac-types/dist/GraphQLGateway.gql.types';
import { last } from 'lodash';
import React, { useState } from 'react';
import { ANALYTICS_EVENT_CONTAINER_PRICING_TAB, ANALYTICS_SUBJECT_ID_ADDITIONAL_PRICING_EXAMPLE } from "../../../../../analytics/Events";
import { TEST_ID } from "../../../../../constants";
import { useAppPricingPlan } from "../hooks";
import { BILLING_CYCLE_FOR_HOSTING, DEFAULT_ERROR_MESSAGE_PRICING_FAILED, MAX_INITIAL_TIERS_TO_DISPLAY } from "../PricingTab.constants";
import { PricingDescription as Description } from "../PricingTab.styles";
import PricingGrid from "./PricingGrid";
import PricingTable from "./PricingTable";
import { AdditionalPricingSection, PricingTiersContainer } from "./PricingTiers.styles";
import PricingTiersSkeleton from "./PricingTiersSkeleton";
export var AdditionalTiersLabel = function AdditionalTiersLabel(props) {
  var hasAdditionalTiers = props.hasAdditionalTiers,
      finalTier = props.finalTier,
      tierType = props.tierType;
  if (!hasAdditionalTiers) return null;
  var floor = finalTier.floor,
      ceiling = finalTier.ceiling;

  if (tierType === MarketplacePricingTierTypeValues.RemoteAgentTiered) {
    return /*#__PURE__*/React.createElement("strong", null, floor, "+ agents?");
  }

  return ceiling ? /*#__PURE__*/React.createElement("strong", null, ceiling, "+ users?") : null;
};

var PricingTiers = function PricingTiers(_ref) {
  var appId = _ref.appId,
      hosting = _ref.hosting,
      mpacBaseUrl = _ref.mpacBaseUrl;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      modalIsOpen = _useState2[0],
      setModalIsOpen = _useState2[1];

  var _useAnalyticsEvents = useAnalyticsEvents(),
      createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;

  var applicableBillingCycle = BILLING_CYCLE_FOR_HOSTING[hosting];

  var _useAppPricingPlan = useAppPricingPlan({
    appId: appId,
    hosting: hosting,
    mpacBaseUrl: mpacBaseUrl,
    billingCycle: applicableBillingCycle
  }),
      data = _useAppPricingPlan.data,
      error = _useAppPricingPlan.error;

  if (error) {
    return /*#__PURE__*/React.createElement("div", null, DEFAULT_ERROR_MESSAGE_PRICING_FAILED);
  }

  if (!data) {
    return /*#__PURE__*/React.createElement(PricingTiersSkeleton, null);
  }

  var _data$tieredPricing = data.tieredPricing,
      items = _data$tieredPricing.items,
      tierType = _data$tieredPricing.tierType,
      tiersMode = _data$tieredPricing.tiersMode,
      currency = data.currency;

  var closeModal = function closeModal() {
    return setModalIsOpen(false);
  };

  var openModal = function openModal(event) {
    var target = event.target;

    if (target instanceof window.Element) {
      createAnalyticsEvent({
        eventType: LinkClickedEvent,
        actionSubjectId: ANALYTICS_SUBJECT_ID_ADDITIONAL_PRICING_EXAMPLE,
        attributes: {
          eventContainer: ANALYTICS_EVENT_CONTAINER_PRICING_TAB,
          // eslint-disable-next-line unicorn/prefer-dom-node-text-content
          label: target.innerText
        }
      }).fire();
    }

    setModalIsOpen(true);
  };

  var tiers = items.slice(0, MAX_INITIAL_TIERS_TO_DISPLAY);
  var hasAdditionalTiers = items.length > tiers.length;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Description, null, "Free for 30 days for teams of all sizes."), /*#__PURE__*/React.createElement(PricingTiersContainer, null, /*#__PURE__*/React.createElement(PricingGrid, {
    items: tiers,
    currency: currency,
    tierType: tierType,
    hosting: hosting,
    billingCycle: applicableBillingCycle
  }), hasAdditionalTiers && /*#__PURE__*/React.createElement(AdditionalPricingSection, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(AdditionalTiersLabel, {
    hasAdditionalTiers: hasAdditionalTiers,
    finalTier: last(tiers),
    tierType: tierType
  }), ' ', /*#__PURE__*/React.createElement(Button, {
    appearance: "link",
    onClick: openModal,
    testId: TEST_ID.PRICING_TAB_VIEW_ADDITIONAL_PRICING
  }, tiersMode === MarketplacePricingTierModeValues.Graduated ? 'View additional pricing examples' : 'View additional pricing details')))), hasAdditionalTiers && /*#__PURE__*/React.createElement(ModalTransition, null, modalIsOpen && /*#__PURE__*/React.createElement(Modal, {
    actions: [{
      text: 'Close',
      onClick: closeModal
    }],
    onClose: closeModal,
    width: "small",
    heading: "".concat(HostingDisplayName[hosting], " Pricing")
  }, /*#__PURE__*/React.createElement(PricingTable, {
    currency: currency,
    items: items,
    tierType: tierType,
    hosting: hosting,
    billingCycle: applicableBillingCycle
  }))));
};

export default PricingTiers;